import { SpyneTrait, safeClone, DomElementTemplate } from "spyne";

export class PageDocsCardCalloutTraits extends SpyneTrait {
  constructor(context) {
    let traitPrefix = "cardCallout$";

    super(context, traitPrefix);
  }

  static cardCallout$Init(props = this.props) {
    const parentEl = props.el.parentElement;
    const parentClass = String(
      `parent-card-callout-${props.data.type}`,
    ).toLowerCase();
    parentEl.classList.add(parentClass);
  }

  static cardCallout$RenderCoreConceptChart() {
    const jsonObj = this.props.data.content;
    const template = `\t<li class="core-concept-item {{classVal}}">
\t<p><b>{{title}}</b><em>:</em>  <span class="core-concept-desc">{{description}}</span></p>
\t\t<ul class='core-concept-list'></ul> 
\t</li>`;

    const chartEl = this.props.el$(".callout-chart").el;
    // Recursive helper function to build nested items
    function buildNestedItems(items, tmpl) {
      //console.log("ITEMS ARE ", { tmpl }, items);
      // Create a DocumentFragment to hold this level of items
      const fragment = document.createDocumentFragment();

      items.forEach((item) => {
        // Use SpyneJS DomElementTemplate to convert (template, itemData) → DocumentFragment
        const docFrag = new DomElementTemplate(tmpl, item).renderDocFrag();

        // If this item has sub-content, we recursively build it and append to the .core-concept-list inside docFrag
        if (Array.isArray(item.content) && item.content.length > 0) {
          const subUl = docFrag.querySelector(".core-concept-list");
          if (subUl) {
            const childFrag = buildNestedItems(item.content, tmpl);
            subUl.appendChild(childFrag);
          }
        }

        // Append this item (li) to the current fragment
        fragment.appendChild(docFrag);
      });

      return fragment;
    }

    // Find the top-level <ul> (or container) in chartEl where we will place the items
    // (If chartEl has a known <ul class='core-concept-list'> or some placeholder)
    const topUl = chartEl.querySelector(".core-concept-list");
    if (!topUl) {
      console.warn(
        "renderCoreConceptChart: No .core-concept-list found in chartEl!",
      );
      return;
    }

    // Build the nested structure from jsonObj
    const topLevelFrag = buildNestedItems(jsonObj, template);

    // Clear out existing contents (if needed), then append
    topUl.innerHTML = "";
    topUl.appendChild(topLevelFrag);
  }

  static cardCallout$GenerateTable(props = this.props) {
  //console.log"THE DATA ", this.props.data.content);

    const createRow = (d, depth = 0, type = "detail") => {
      const data = safeClone(d);
      data["depth"] = depth;
      data["rowClass"] = [
        "subject",
        "detail",
        "property",
        "empty-1",
        "empty-2",
      ][depth];

      const tmpl = PageDocsCardCalloutTraits.cardCallout$GetTemplate(type);
      const domTmpl = new DomElementTemplate(tmpl, data);

      // You can also use depth in logic here:
      // e.g., apply conditional classes or inline styles based on depth
      // const rowClass = depth === 0 ? 'top-level' : `nested-level-${depth}`;

      return domTmpl.renderToString();
    };

    const reducerToHTMLStr = (acc, o, depth = 0) => {
      acc += "\n" + createRow(o, depth);

      if (Array.isArray(o?.content)) {
        acc = o.content.reduce((innerAcc, innerO) => {
          return reducerToHTMLStr(innerAcc, innerO, depth + 1);
        }, acc);
      }

      return acc;
    };

    // Start at depth 0
    const finalHTMLStr = this.props.data.content.reduce(
      (acc, o) => reducerToHTMLStr(acc, o, 0),
      "",
    );

   //console.log'FINAL STR IS ', finalHTMLStr);

    return finalHTMLStr;
  }

  static cardCallout$GetTemplate(type = "detail") {
    const detailTempl = `
      <div class="callout-row row-{{rowClass}} level-{{depth}}">
    <div class="callout-item callout-title"><p class="callout-title">{{title}}</p></div>
    <div class="callout-item callout-description"><p class="callout-description">{{description}}</p></div>
  </div>
    
    `;

    const templateLookup = {
      detail: detailTempl,
    };

    return templateLookup[type] || "<h4>EMPTY</h4>";
  }

  static cardCallout$HelloWorld() {
    return "Hello World";
  }
}
